<template>
  <div class="col-12">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div
        class="row bg-light-gray border-radius--light pb-3 pt-1"
        style="border-radius: 5px 5px 0px 0px"
      >
        <div class="col-12 col-sm-6 col-md-4 mb-4">
          <ValidationProvider
            v-slot="{ errors }"
            name="Tipo de Recurso"
            rules="required"
          >
            <label class="input-label">Tipo de Recurso:</label>
            <CustomDropDown
              v-model="model.resourceType"
              :options="collections.resourceTypes"
              :error="errors[0]"
              custom-error-msg="El tipo de recurso es requerido."
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mb-4">
          <ValidationProvider
            v-slot="{ errors }"
            :name="agreementNumberType"
            rules="required"
          >
            <label class="input-label">{{ agreementNumberType }}:</label>
            <CustomInput
              v-model="model.positionNumber"
              :error="errors[0]"
              :custom-error-msg="
                `El ${agreementNumberType.toLowerCase()} es requerido.`
              "
              type="text"
              required
              class="read-only"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mb-4">
          <ValidationProvider
            v-slot="{ errors }"
            name="Tipo de Asistente"
            rules="required"
          >
            <label class="input-label">Tipo de Asistente:</label>
            <CustomDropDown
              v-model="model.assistantType"
              :options="collections.assistantTypes"
              :error="errors[0]"
              custom-error-msg="El tipo de asistente es requerido."
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mb-4">
          <ValidationProvider
            v-slot="{ errors }"
            name="Jornada Diaria"
            rules="required"
          >
            <label class="input-label">Jornada Diaria:</label>
            <CustomDropDown
              v-model="model.dailyShift"
              :options="collections.dailyShifts"
              :error="errors[0]"
              custom-error-msg="La jornada diaria es requerida."
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mb-4">
          <ValidationProvider
            v-slot="{ errors }"
            name="Año Académico"
            rules="required"
          >
            <label class="input-label">Año Académico:</label>
            <CustomDropDown
              v-model="model.academicYear"
              :options="collections.academicYears"
              :error="errors[0]"
              custom-error-msg="El año académico es requerido."
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="description"
              @input="onChangeAcademicYear"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-2 mb-4">
          <ValidationProvider
            ref="fromDateValidator"
            v-slot="{ errors }"
            name="Fecha desde"
            rules="required"
          >
            <label class="input-label">Fecha desde:</label>
            <CustomDatePicker
              v-model="model.fromDate"
              :open-date="openDate(minDate)"
              :min-date="minDate"
              :max-date="maxDate"
              :disabled="!model.academicYear"
              :error="errors[0]"
              custom-error-msg="La fecha desde es requerida."
              class-container="w-100"
              required
              @input="onChangefromDate"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-2 mb-4">
          <ValidationProvider
            ref="toDateValidator"
            v-slot="{ errors }"
            name="Fecha hasta"
            rules="required"
          >
            <label class="input-label">Fecha hasta:</label>
            <CustomDatePicker
              v-model="model.toDate"
              :open-date="openDate(toDateMinDate)"
              :min-date="toDateMinDate"
              :max-date="maxDate"
              :disabled="!model.academicYear"
              :error="errors[0]"
              custom-error-msg="La fecha hasta es requerida."
              class-container="w-100"
              required
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mb-4">
          <ValidationProvider
            ref="regionValidator"
            v-slot="{ errors }"
            name="Region"
            rules="required"
          >
            <label class="text-muted mb-1">Región:</label>
            <CustomDropDown
              v-model="model.region"
              placeholder="Seleccione"
              class="placeholder-black"
              fieldkey="id"
              fieldname="name"
              custom-error-msg="La región es requerida."
              :options="regions"
              :disabled="isDropDownRegionIdDisabled"
              :error="errors[0]"
              @input="onChangeRegion"
            />
          </ValidationProvider>
        </div>

        <div class="col-12 col-sm-6 col-md-4 mb-4">
          <ValidationProvider
            ref="municipalityValidator"
            v-slot="{ errors }"
            name="Municipio"
            rules="required"
          >
            <label class="text-muted mb-1">Municipio:</label>
            <CustomDropDown
              v-model="model.municipality"
              placeholder="Seleccione"
              class="placeholder-black"
              fieldkey="id"
              fieldname="name"
              custom-error-msg="El municipio es requerido."
              :options="municipalities"
              :disabled="isDropDownMunicipalityIdDisabled"
              :error="errors[0]"
              @input="onChangeMunicipality"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mb-4">
          <ValidationProvider
            ref="schoolValidator"
            v-slot="{ errors }"
            name="Escuela"
            rules="required"
          >
            <label class="text-muted mb-1">Escuela:</label>
            <CustomDropDown
              v-model="model.school"
              placeholder="Seleccione"
              class="placeholder-black"
              fieldkey="id"
              fieldname="name"
              custom-error-msg="La escuela es requerida."
              :options="schools"
              :disabled="isDropDownSchoolDisabled"
              :error="errors[0]"
            />
          </ValidationProvider>
        </div>
        <div class="col-12 col-sm-6 col-md-4 mb-4">
          <ValidationProvider
            v-slot="{ errors }"
            name="Tiempo en Servicio"
            rules="required"
          >
            <label class="input-label">Tiempo en Servicio:</label>
            <CustomInput
              v-model="model.timeInService"
              :error="errors[0]"
              custom-error-msg="El tiempo en servicio es requerido."
              type="text"
              required
              class="read-only"
            />
          </ValidationProvider>
        </div>
      </div>
      <div
        class="row bg-light-gray border-radius--light pb-3  pt-1"
        style="border-radius: 0px 0px 5px 5px"
      >
        <div
          class="col-12 col-md-2 offset-md-10 pl-3 pr-2 d-flex align-items-end justify-content-end"
        >
          <ActionButton
            variant="outline-danger m-1"
            :i="`fas fa-times-circle`"
            :responsive="true"
            @click="cancel"
          >
            Cancelar
          </ActionButton>
          <ActionButton
            variant="success m-1"
            :i="`fas fa-${editting ? 'save' : 'file-plus'}`"
            :responsive="true"
            @click="handleSubmit(submit)"
          >
            {{ editting ? 'Guardar' : 'Añadir' }}
          </ActionButton>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';
import locationService from '@/services/api/location.api';
import auxiliaryTypeCodes from '@/utils/constants/hrrequest/auxiliaryTypeCodes';
import moment from 'moment';

const modelInitialState = () => ({
  id: 0,
  resourceType: null,
  positionNumber: null,
  assistantType: null,
  dailyShift: null,
  academicYear: null,
  fromDate: null,
  toDate: null,
  region: null,
  municipality: null,
  school: null,
  timeInService: null,
});

export default {
  name: 'SchoolInformationForm',
  components: {
    CustomInput,
    ActionButton,
    CustomDropDown,
    CustomDatePicker,
  },
  props: {
    item: { type: Object, default: null },
    editting: { type: Boolean, default: false },
    collections: { type: Object, required: true },
  },
  data: () => ({
    model: modelInitialState(),
    regions: [],
    municipalities: [],
    schools: [],
  }),
  computed: {
    isDropDownRegionIdDisabled() {
      return this.regions && this.regions.length <= 1;
    },
    isDropDownMunicipalityIdDisabled() {
      return this.municipalities && this.municipalities.length <= 1;
    },
    isDropDownSchoolDisabled() {
      return this.schools && this.schools.length <= 1;
    },
    minDate() {
      if (this.model.academicYear) {
        const date = new Date(this.model.academicYear.fromDate);
        date.setDate(date.getDate() - 1);
        return date;
      }
      return new Date();
    },
    maxDate() {
      if (this.model.academicYear) {
        const date = new Date(this.model.academicYear.toDate);
        return date;
      }
      return new Date();
    },
    toDateMinDate() {
      if (this.model.fromDate) return new Date(this.model.fromDate);
      return this.minDate;
    },
    openDate() {
      return (date) => {
        const openDate = new Date(date);
        openDate.setDate(date.getDate() + 1);
        return openDate;
      };
    },
    agreementNumberType() {
      return `Número de ${
        !this.model.resourceType ||
        this.model.resourceType.id == auxiliaryTypeCodes.irregular
          ? 'Contrato'
          : 'Puesto'
      }`;
    },
  },
  methods: {
    onChangefromDate(fromDate) {
      if (
        fromDate &&
        this.model.toDate &&
        moment(fromDate).isAfter(this.model.toDate)
      )
        this.resetFields(['toDate']);
    },
    async onChangeAcademicYear(academicYear) {
      this.resetFields([
        'region',
        'municipality',
        'school',
        'fromDate',
        'toDate',
      ]);
      this.regions = [];
      this.municipalities = [];
      this.schools = [];
      if (academicYear) {
        await this.fetchRegions(academicYear.id);
      }
    },
    async onChangeRegion(region) {
      this.resetFields(['municipality', 'school']);
      this.municipalities = [];
      this.schools = [];
      if (region) {
        await this.fetchMunicipalities(region.id);
      }
    },
    async onChangeMunicipality(municipality) {
      this.resetFields(['school']);
      this.schools = [];
      if (municipality) {
        await this.fetchSchools(municipality.id);
      }
    },
    async fetchRegions(academicYearId) {
      const { data } = await locationService.getRegions({
        academicYearId,
        ignoreUserProfile: true,
      });
      this.regions = data;
      if (this.regions && this.regions.length == 1) {
        this.model.region = this.regions[0];
        await this.fetchMunicipalities(this.model.region.id);
      }
    },
    async fetchMunicipalities(regionId) {
      const { data } = await locationService.getMunicipalities({
        regionId,
        academicYearId: this.model.academicYear.id,
        ignoreUserProfile: true,
      });
      this.municipalities = data;
      if (this.municipalities && this.municipalities.length == 1) {
        this.model.municipality = this.municipalities[0];
        await this.fetchSchools(this.model.municipality.id);
      }
    },
    async fetchSchools(municipalityId) {
      const { data } = await locationService.getSchools({
        municipalityId,
        academicYearId: this.model.academicYear.id,
        ignoreUserProfile: true,
      });
      this.schools = data;
      if (this.schools && this.schools.length == 1) {
        this.model.school = this.schools[0];
        await this.getCustodianList(this.model.school.id);
      }
    },
    resetFields(fields) {
      fields.forEach((field) => {
        this.model[field] = null;
        this.$refs[`${field}Validator`].reset();
      });
    },
    submit() {
      this.$emit('submit', this.model, this.cancel);
    },
    cancel() {
      this.model = modelInitialState();
      this.$refs['form'].reset();
      this.$emit('cancel');
    },
  },
  created() {
    if (this.item) {
      this.model = { ...this.model, ...this.item };
      this.fetchRegions(this.model.academicYear.id);
      this.fetchMunicipalities(this.model.region.id);
      this.fetchSchools(this.model.municipality.id);
    }
  },
};
</script>

<style lang="scss" scoped>
.input-label {
  color: #727272;
  font-size: 15px;
  font-weight: lighter;
}
.was-Invalidated {
  border: 1px solid red;
}
::v-deep .student-search-alert-error {
  height: 0;
}
</style>
